module.exports = __webpack_public_path__ + "img/icon-contract.88ae7e72.png";